// extracted by mini-css-extract-plugin
export var container = "index-module--container--e6852";
export var footer = "index-module--footer--8aefb";
export var langSitchContainer = "index-module--langSitchContainer--506dd";
export var langSwitch = "index-module--langSwitch--e800c";